package com.eladfinish.bible.contest.features.copyOptions.model

import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import kotlinx.collections.immutable.ImmutableList

sealed interface CopyOptionsInput {
    data class PlainText(
        val rawText: String,
    ) : CopyOptionsInput

    data class SingleSearchResult(
        val item: VerseUiModel,
    ) : CopyOptionsInput

    data class SearchResultsV2(
        val originalExpression: String,
        val items: ImmutableList<VerseUiModel>,
    ) : CopyOptionsInput
}
